import { network } from 'services/network';

import { QueryParams } from 'api/mutations/updateSegment.mutation';

export const updateSegment = (params: QueryParams) => {
    return network.post('api/bo/updateSegment', params).then((response) => {
        return response.data;
    });
};
